angular.module("app").directive("unicornPopularColorCombination", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbUnicornPopularColorCombination/dbUnicornPopularColorCombinationView.html",
    link: link,
    scope: {
      selectedColor: "=",
      data: "="
    }
  };
});
